module.exports = __webpack_public_path__ + "img/EZ(1).14e16851.jpg";